/** 钱包账户API */
import type { Api } from '@/typings/api';
import { download, post } from '../../request';
const prefix = '/finance/financeWallet';
/**
 * 分页查询钱包账户
 *
 * @param params 查询参数
 */
export const findPage: Api.CommonMethods.FindPage<Api.Finance.FinanceWallet> = params => {
  return post(`${prefix}/findPage`, params);
};
/**
 * 查询钱包账户列表
 *
 * @param params 查询参数
 */
export const findAll: Api.CommonMethods.FindAll<Api.Finance.FinanceWallet> = params => {
  return post(`${prefix}/findAll`, params);
};
/**
 * 查询单个钱包账户
 *
 * @param id 钱包账户ID
 * @param column 查询字段
 */
export const findOne: Api.CommonMethods.FindOne<Api.Finance.FinanceWallet> = (id: string, column?: string[]) => {
  return post(`${prefix}/findOne`, { id, column });
};
/**
 * 保存钱包账户
 *
 * @param params 钱包账户信息
 */
export const doSave: Api.CommonMethods.Save = params => {
  return post(`${prefix}/save`, params);
};
/**
 * 更新钱包账户信息
 *
 * @param params 钱包账户信息
 */
export const doUpdate: Api.CommonMethods.Update = params => {
  return post(`${prefix}/update`, params);
};
/**
 * 删除钱包账户
 *
 * @param id 钱包账户ID
 */
export const doDelete: Api.CommonMethods.Delete = id => {
  return post(`${prefix}/delete?id=${id}`);
};
/**
 * 批量删除钱包账户
 *
 * @param ids 钱包账户ID数组
 */
export const doBatchDelete: Api.CommonMethods.BatchDelete = ids => {
  return post(`${prefix}/deleteList`, { ids });
};

/**
 * 导出
 *
 * @param params
 * @returns
 */
export const doExport = (params: Api.Common.CommonSearchParams) => {
  return download(`${prefix}/export`, params);
};

export default {
  findPage,
  findOne,
  doSave,
  doUpdate,
  doDelete,
  doBatchDelete
};
